export default __webpack_public_path__ + "static/media/facebook.008ddcf1.svg";